import { RiskLevel } from "@/model/RiskLevel";
import { NullBanner } from "@/model/DefaultBanners";
import Logo from "@/assets/regions/bolton-logo.png";
const BoltonLower = {
    rawCopy: "Keep up the good work.",
};
const BoltonIncreasing = {
    rawCopy: `For Increasing Risk scores we recommend that you cut down your drinking. <u>Click here to book a free online appointment</u> with a DrinkCoach.`,
    logoLink: "https://bookdrinkcoach.as.me/bolton"
};
const BoltonHigher = {
    rawCopy: `For Higher Risk scores we recommend that you cut down your drinking. Click here to <u>book a free online appointment</u> with a DrinkCoach.`,
    logoLink: "https://bookdrinkcoach.as.me/bolton"
};
const BoltonHigh = {
    rawCopy: `For alcohol advice and support in Bolton call Better Days on 01204 483 090 or email <u>info@BetterDaysBolton.org.uk</u>`,
    logoLink: "mailto:info@BetterDaysBolton.org.uk"
};
export default {
    name: "Bolton",
    zoomLevel: 17,
    logo: {
        file: Logo,
        width: 480,
        height: 454
    },
    hasFreeAppointments: true,
    showServiceInfoOnResultsSummaryPage: true,
    bannerInfo: {
        default: NullBanner,
        [RiskLevel.Lower]: BoltonLower,
        [RiskLevel.Increasing]: BoltonIncreasing,
        [RiskLevel.Higher]: BoltonHigher,
        [RiskLevel.High]: BoltonHigh
    },
    clinics: [
        {
            name: "Better Days Bolton",
            phone: ["01204 483 090"],
            description: "Contact ${name} on <a href='tel:${phone}'>${phone}</a> or email <a href='mailto:${email}'>${email}</a>",
            isPrimaryProvider: true,
            linkToSupportFinderInAddress: true,
            address: "Le Mans Crescent, Queen Street BL1 1SX",
            location: { lat: 53.5780148, lng: -2.4344151 },
            times: [
                {
                    title: "Opening times:",
                    info: "<br>Mon to Fri: 9am – 5pm<br>" +
                        "Late night opening on Thursdays (7.30pm)"
                }
            ],
            email: "info@betterdaysbolton.org.uk",
            website: "https://www.waythrough.org.uk/find-support-near-me/better-days-bolton/"
        },
        {
            name: "Better Days Bolton",
            phone: ["01204 483 090"],
            description: "Contact ${name} on <a href='tel:${phone}'>${phone}</a> or email <a href='mailto:${email}'>${email}</a>",
            address: "Le Mans Crescent, Queen Street BL1 1SX",
            times: [
                {
                    title: "Opening times:",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1930 }],
                        friday: [{ start: 900, end: 1700 }]
                    }
                }
            ],
            email: "info@betterdaysbolton.org.uk",
            website: "https://www.waythrough.org.uk/find-support-near-me/better-days-bolton/"
        }
    ]
};
//# sourceMappingURL=Bolton.js.map